module.exports = __webpack_public_path__ + "img/KH.3b48ae82.png";